import { PecaDetalhe3D as Peca } from './PecaDetalhe3D'

export function FiguraCone3D() {
  return (
    <group>
      <Peca
        posicao={[0, 0.055, 0]}
        tamanho={[0.64, 0.11, 0.64]}
        cor="#242b30"
        raio={0.055}
        rugosidade={0.95}
      />
      <mesh position={[0, 0.44, 0]} castShadow>
        <cylinderGeometry args={[0.045, 0.235, 0.68, 14]} />
        <meshStandardMaterial color="#ef7f2c" roughness={0.65} />
      </mesh>
      {[0.35, 0.57].map((y) => {
        const raio = 0.235 - ((y - 0.1) / 0.68) * 0.19
        return (
          <mesh key={y} position={[0, y, 0]}>
            <cylinderGeometry args={[raio - 0.01, raio + 0.013, 0.075, 14]} />
            <meshStandardMaterial color="#f0efe4" roughness={0.4} />
          </mesh>
        )
      })}
    </group>
  )
}

export function FiguraBueiro3D() {
  return (
    <group>
      <Peca
        posicao={[0, 0.05, 0]}
        tamanho={[2, 0.1, 2]}
        cor="#88928d"
        raio={0.04}
        rugosidade={0.9}
      />
      <Peca
        posicao={[0, 0.105, 0]}
        tamanho={[1.72, 0.02, 1.72]}
        cor="#18232a"
        raio={0.02}
      />
      {[-0.84, 0.84].map((v) => (
        <group key={v}>
          <Peca
            posicao={[v, 0.12, 0]}
            tamanho={[0.08, 0.03, 1.76]}
            cor="#52636a"
            raio={0.008}
            metal={0.5}
          />
          <Peca
            posicao={[0, 0.12, v]}
            tamanho={[1.76, 0.03, 0.08]}
            cor="#52636a"
            raio={0.008}
            metal={0.5}
          />
        </group>
      ))}
      {Array.from({ length: 9 }, (_, i) => (
        <Peca
          key={i}
          posicao={[-0.72 + i * 0.18, 0.12, 0]}
          tamanho={[0.065, 0.04, 1.62]}
          cor="#5c6b70"
          raio={0.008}
          metal={0.55}
          rugosidade={0.55}
        />
      ))}
      {[-0.76, 0.76].flatMap((x) =>
        [-0.76, 0.76].map((z) => (
          <mesh key={`${x}-${z}`} position={[x, 0.146, z]}>
            <cylinderGeometry args={[0.025, 0.025, 0.025, 6]} />
            <meshStandardMaterial color="#b0bbc0" metalness={0.7} />
          </mesh>
        )),
      )}
    </group>
  )
}

export function FiguraFita3D() {
  return (
    <group>
      {[-10, 0, 10].map((x) => (
        <group key={x}>
          <Peca
            posicao={[x, 0.035, 0]}
            tamanho={[0.5, 0.07, 0.5]}
            cor="#26333b"
            raio={0.04}
          />
          <mesh position={[x, 0.59, 0]} castShadow>
            <cylinderGeometry args={[0.035, 0.035, 1.1, 8]} />
            <meshStandardMaterial color="#87999f" metalness={0.5} />
          </mesh>
        </group>
      ))}
      {Array.from({ length: 40 }, (_, i) => (
        <mesh key={i} position={[-9.75 + i * 0.5, 1.06, 0]}>
          <boxGeometry args={[0.5, 0.115, 0.018]} />
          <meshStandardMaterial
            color={i % 2 ? '#243139' : '#f2ce42'}
            roughness={0.65}
          />
        </mesh>
      ))}
    </group>
  )
}

export function FiguraAreaApoio3D({
  tipo,
}: {
  tipo: 'corredorDescontaminacao' | 'areaVitimas' | 'postoComando'
}) {
  const descontaminacao = tipo === 'corredorDescontaminacao'
  return (
    <group name={tipo}>
      <Peca
        posicao={[0, 0.04, 0]}
        tamanho={[descontaminacao ? 6 : 12, 0.08, 20]}
        cor={tipo === 'areaVitimas' ? '#865c5e' : '#517e79'}
        raio={0.02}
        rugosidade={0.95}
      />
      {descontaminacao ? (
        <group name="estrutura-descontaminacao">
          {[-2.9, 2.9].map((x) => (
            <Peca
              key={x}
              posicao={[x, 0.18, 0]}
              tamanho={[0.15, 0.28, 20]}
              cor="#315657"
              raio={0.025}
            />
          ))}
          {[-7, 0, 7].map((z) => (
            <group key={z}>
              {[-2.65, 2.65].map((x) => (
                <group key={x}>
                  <mesh position={[x, 1.49, z]} castShadow>
                    <cylinderGeometry args={[0.065, 0.065, 2.8, 10]} />
                    <meshStandardMaterial
                      color="#b5c7cc"
                      metalness={0.65}
                      roughness={0.4}
                    />
                  </mesh>
                  <Peca
                    posicao={[x, 0.16, z]}
                    tamanho={[0.4, 0.14, 0.4]}
                    cor="#31565c"
                    raio={0.025}
                  />
                </group>
              ))}
              <Peca
                posicao={[0, 2.88, z]}
                tamanho={[5.44, 0.13, 0.13]}
                cor="#b5c7cc"
                metal={0.65}
                raio={0.025}
              />
              {[-1.7, 0, 1.7].map((x) => (
                <mesh key={x} position={[x, 2.77, z]}>
                  <cylinderGeometry args={[0.035, 0.065, 0.13, 10]} />
                  <meshStandardMaterial color="#6c929b" metalness={0.6} />
                </mesh>
              ))}
            </group>
          ))}
          {[-2.65, 2.65].map((x) => (
            <Peca
              key={x}
              posicao={[x, 2.85, 0]}
              tamanho={[0.09, 0.09, 14]}
              cor="#88a4ac"
              raio={0.02}
              metal={0.55}
            />
          ))}
          {[-5, 0, 5].map((z) => (
            <Peca
              key={z}
              posicao={[0, 0.093, z]}
              tamanho={[3.8, 0.025, 0.18]}
              cor="#c5d0c9"
              raio={0.008}
            />
          ))}
          <mesh position={[-3.45, 0.14, -6]} rotation={[Math.PI / 2, 0, 0]}>
            <torusGeometry args={[0.4, 0.06, 6, 18]} />
            <meshStandardMaterial color="#243e48" roughness={0.9} />
          </mesh>
        </group>
      ) : tipo === 'postoComando' ? (
        <group name="tenda-comando">
          {[-4.9, 4.9].flatMap((x) =>
            [-3.5, 3.5].map((z) => (
              <mesh key={`${x}-${z}`} position={[x, 1.56, z]} castShadow>
                <cylinderGeometry args={[0.07, 0.07, 3, 10]} />
                <meshStandardMaterial color="#b5c1c4" metalness={0.65} />
              </mesh>
            )),
          )}
          {[-1, 1].map((lado) => (
            <Peca
              key={lado}
              posicao={[lado * 2.5, 3.38, 0]}
              tamanho={[5.14, 0.08, 7.6]}
              cor="#d4c59b"
              raio={0.02}
              rotacao={[0, 0, -lado * 0.13]}
              rugosidade={0.9}
            />
          ))}
          <Peca
            posicao={[0, 0.89, 0]}
            tamanho={[3.5, 0.12, 1.5]}
            cor="#84938d"
            raio={0.04}
          />
          {[-1.4, 1.4].flatMap((x) =>
            [-0.55, 0.55].map((z) => (
              <Peca
                key={`${x}-${z}`}
                posicao={[x, 0.48, z]}
                tamanho={[0.06, 0.78, 0.06]}
                cor="#b8c3c3"
                raio={0.015}
                metal={0.55}
              />
            )),
          )}
          <Peca
            posicao={[0, 0.958, 0]}
            tamanho={[1.7, 0.012, 1]}
            cor="#d9e0cf"
            raio={0.004}
          />
          <Peca
            posicao={[1.18, 1.1, 0]}
            tamanho={[0.42, 0.29, 0.35]}
            cor="#2f414d"
            raio={0.03}
          />
          <Peca
            posicao={[1.32, 1.41, 0]}
            tamanho={[0.025, 0.36, 0.025]}
            cor="#354550"
            raio={0.006}
          />
          <Peca
            posicao={[-4, 1.48, -2.8]}
            tamanho={[2.1, 1.18, 0.11]}
            cor="#e2e6dd"
            raio={0.035}
          />
          <Peca
            posicao={[-4, 0.78, -2.8]}
            tamanho={[0.1, 1.43, 0.1]}
            cor="#758a94"
            raio={0.02}
          />
        </group>
      ) : (
        <group name="area-concentracao-vitimas">
          {[-4, 0, 4].map((x, i) => (
            <group key={x}>
              <mesh position={[x, 0.73, -7]} castShadow>
                <cylinderGeometry args={[0.025, 0.025, 1.3, 8]} />
                <meshStandardMaterial color="#a6b5b9" metalness={0.5} />
              </mesh>
              <Peca
                posicao={[x + 0.2, 1.18, -7]}
                tamanho={[0.4, 0.24, 0.02]}
                cor={['#dc655e', '#e3c965', '#65a876'][i]!}
                raio={0.005}
              />
              <Peca
                posicao={[x, 0.49, 0]}
                tamanho={[0.65, 0.1, 2]}
                cor="#74888d"
                raio={0.04}
              />
              <Peca
                posicao={[x, 0.56, 0]}
                tamanho={[0.53, 0.045, 1.79]}
                cor="#55736c"
                raio={0.02}
              />
              {[-0.32, 0.32].map((dx) => (
                <Peca
                  key={dx}
                  posicao={[x + dx, 0.49, 0]}
                  tamanho={[0.04, 0.04, 2.3]}
                  cor="#bac6c8"
                  raio={0.01}
                  metal={0.6}
                />
              ))}
              {[-0.7, 0.7].map((z) => (
                <Peca
                  key={z}
                  posicao={[x, 0.31, z]}
                  tamanho={[0.57, 0.32, 0.045]}
                  cor="#8b9fa6"
                  raio={0.012}
                  metal={0.5}
                />
              ))}
            </group>
          ))}
        </group>
      )}
    </group>
  )
}
